import React from 'react'
import styled from 'styled-components'
import useShop from '../context/AppContext'
import { IconTabs } from '../assets/icons'
import { images } from '../constants'
import { motion } from 'framer-motion'

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: calc(100dvh - 100px);
  padding: 100px 0 140px;
  @media screen and (max-width: 1023px) {
    padding: 100px 0 120px;
  }
  @media screen and (max-width: 800px) {
    padding: 60px 0 100px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(100% - 500px);
  padding: 0 30px 0 0;
  @media screen and (max-width: 1023px) {
    width: calc(100% - 400px);
    padding: 0 15px 0 0;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding: 0 0 20px 0;
  }
  h1 {
    line-height: 1.25;
    margin-bottom: 15px;
  }
  h3 {
    font-size: var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 30px;
  }
`
const RightColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 500px;
  height: auto;
  .level-1 {
    display: block;
    width: 500px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .level-2,
  .level-3,
  .level-4,
  .level-5,
  .level-6 {
    display: block;
    width: 500px;
    position: absolute;
    img {
      width: 100%;
      height: auto;
    }
  }
  @media screen and (max-width: 1023px) {
    width: 400px;
    .level-1,
    .level-2,
    .level-3,
    .level-4,
    .level-5,
    .level-6 {
      width: 400px;
    }
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    align-items: flex-start;
    .level-1,
    .level-2,
    .level-3,
    .level-4,
    .level-5,
    .level-6 {
      width: 100%;
      max-width: 500px;
    }
  }
`
const InnerService = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  img {
    opacity: 0.9;
    width: 20px;
  }
  .service-style {
    display: inline-block;
    margin: 0 0 1px 12px;
    color: var(--text);
    font-size: var(--fz-sm);
    font-weight: 500;
    line-height: 1;
  }
`
const ArticleHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 86%;
  max-width: var(--max-width);
  margin: 90px auto 20px;
  svg.tab-icon {
    width: 52px;
    height: 52px;
    path {
      fill: var(--service-design);
    }
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
    margin: 60px auto 20px;
  }
`
const ArticleColumns = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const ArticleOne = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 40%;
  padding-right: 40px;
  h3 {
    margin-bottom: 20px;
    font-family: var(--font-sans);
    font-size: var(--fz-md);
    font-weight: 600;
    line-height: 1.5;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding-right: 0px;
    padding-bottom: 20px;
  }
`
const ArticleTwo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  position: relative;
  width: 60%;
  margin-top: -40px;
  .article-two {
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
    background-color: var(--black-medium);
    ul {
      display: block;
      margin-left: 18px;
      li {
        margin: 8px 0;
      }
    }
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    margin-top: 20px;
    .article-two {
      padding: 35px 25px;
    }
  }
`

const ServiceHeroCustomIconDesign = () => {
  const { preloaderExecuted, navigationExecuted } = useShop()

  const icon = <img src={images.service_card_shopify} alt="Shopify" />
  const service = <span className="service-style">Design Services</span>
  const title = <h1>Shopify Custom Icon Design.</h1>
  const subtitle = <h3>Do you need icons that best match your 's statements and services? I can design icons that align with your brand and can be used on multiple platforms.</h3>

  return (
    <SectionWrapper>
      <SectionContainer>
        {preloaderExecuted && navigationExecuted ? (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.1, duration: 0.3 }} className="start-opacity">
              <InnerService>
                {icon}
                {service}
              </InnerService>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.2, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
          </LeftColumn>
        ) : (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1, duration: 0.3 }} className="start-opacity">
              <InnerService>
                {icon}
                {service}
              </InnerService>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.1, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
          </LeftColumn>
        )}
        {preloaderExecuted && navigationExecuted ? (
          <RightColumn>
            <RightColumn>
              <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.5 }} className="start-opacity level-1">
                <img src={images.roberteberhard_service_theme_background} alt="Image Converting Newsletter Design" />
              </motion.div>
              <motion.div animate={{ y: [10, 0], opacity: [0, 1] }} transition={{ delay: 0.6, duration: 0.5 }} className="start-opacity level-2">
                <img src={images.roberteberhard_service_design_theme_custom_icon_design_1} alt="" />
              </motion.div>
              <motion.div animate={{ x: [-20, 0], y: [-20, 0], scale: [1.25, 1], opacity: [0, 1] }} transition={{ delay: 0.7, duration: 0.5 }} className="start-opacity level-3">
                <img src={images.roberteberhard_service_design_theme_custom_icon_design_2} alt="" />
              </motion.div>
              <motion.div animate={{ x: [20, 0], y: [-20, 0], scale: [1.25, 1], opacity: [0, 1] }} transition={{ delay: 0.8, duration: 0.5 }} className="start-opacity level-4">
                <img src={images.roberteberhard_service_design_theme_custom_icon_design_3} alt="" />
              </motion.div>
              <motion.div animate={{ x: [-20, 0], y: [-10, 0], scale: [15, 1], opacity: [0, 1] }} transition={{ delay: 0.9, duration: 0.5 }} className="start-opacity level-5">
                <img src={images.roberteberhard_service_design_theme_custom_icon_design_4} alt="" />
              </motion.div>
              <motion.div animate={{ x: [200, 0], y: [150, 0], opacity: [0, 1] }} transition={{ delay: 1, duration: 0.5 }} className="start-opacity level-6">
                <img src={images.roberteberhard_service_design_theme_custom_icon_design_5} alt="" />
              </motion.div>
            </RightColumn>
          </RightColumn>
        ) : (
          <RightColumn>
            <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.5 }} className="start-opacity level-1">
              <img src={images.roberteberhard_service_theme_background} alt="Image Custom Icon Design" />
            </motion.div>
            <motion.div animate={{ y: [10, 0], opacity: [0, 1] }} transition={{ delay: 1.5, duration: 0.5 }} className="start-opacity level-2">
              <img src={images.roberteberhard_service_design_theme_custom_icon_design_1} alt="" />
            </motion.div>
            <motion.div animate={{ x: [-20, 0], y: [-20, 0], scale: [1.25, 1], opacity: [0, 1] }} transition={{ delay: 1.6, duration: 0.5 }} className="start-opacity level-3">
              <img src={images.roberteberhard_service_design_theme_custom_icon_design_2} alt="" />
            </motion.div>
            <motion.div animate={{ x: [20, 0], y: [-20, 0], scale: [1.25, 1], opacity: [0, 1] }} transition={{ delay: 1.7, duration: 0.5 }} className="start-opacity level-4">
              <img src={images.roberteberhard_service_design_theme_custom_icon_design_3} alt="" />
            </motion.div>
            <motion.div animate={{ x: [-20, 0], y: [-10, 0], scale: [15, 1], opacity: [0, 1] }} transition={{ delay: 1.8, duration: 0.5 }} className="start-opacity level-5">
              <img src={images.roberteberhard_service_design_theme_custom_icon_design_4} alt="" />
            </motion.div>
            <motion.div animate={{ x: [200, 0], y: [150, 0], opacity: [0, 1] }} transition={{ delay: 1.9, duration: 0.5 }} className="start-opacity level-6">
              <img src={images.roberteberhard_service_design_theme_custom_icon_design_5} alt="" />
            </motion.div>
          </RightColumn>
        )}
      </SectionContainer>

      {preloaderExecuted && navigationExecuted ? (
        <ArticleHeader>
          <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.9, duration: 0.3 }} className="start-opacity">
            <IconTabs name="shopify-support" />
          </motion.div>
        </ArticleHeader>
      ) : (
        <ArticleHeader>
          <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.8, duration: 0.3 }} className="start-opacity">
            <IconTabs name="shopify-support" />
          </motion.div>
        </ArticleHeader>
      )}

      {preloaderExecuted && navigationExecuted ? (
        <ArticleColumns>
          <ArticleOne>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1, duration: 0.3 }} className="start-opacity">
              <h3>Custom Icon Design is a great way to create a unique and recognizable look for your business.</h3>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.1, duration: 0.3 }} className="start-opacity">
              <p className="mb-15">You can create a unique and recognizable brand identity with custom-designed icons that are tailored to your exact specifications in terms of shapes, sizes, components, and colors.</p>
              <p>With this power, you can create a visual representation of your brand that stands out from the crowd.</p>
            </motion.div>
          </ArticleOne>
          <ArticleTwo>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.3 }} className="start-opacity">
              <div className="article-two">
                <p className="mb-15">Designing custom icons is a great way to create a unique shopping experience for customers. To ensure the icons are effective, I recommend focusing on the following:</p>
                <ul className="mb-15">
                  <li>Keep the icons simple and easy to understand. Complex icons can be confusing and detract from the overall user experience.</li>
                  <li>Make sure the icons are consistent with the overall design of the store. This will help create a cohesive look and feel.</li>
                  <li>Use colors that are in line with the store's branding. This will help customers recognize the icons quickly and easily.</li>
                  <li>Test the icons to make sure they are working properly. This will ensure customers have a smooth and enjoyable shopping experience.</li>
                </ul>
                <p>By following these tips, I am confident that I can create custom icons that will create a unique shopping experience for your customers.</p>
              </div>
            </motion.div>
          </ArticleTwo>
        </ArticleColumns>
      ) : (
        <ArticleColumns>
          <ArticleOne>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.9, duration: 0.3 }} className="start-opacity">
              <h3>Custom Icon Design is a great way to create a unique and recognizable look for your business.</h3>
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 2, duration: 0.3 }} className="start-opacity">
              <p className="mb-15">You can create a unique and recognizable brand identity with custom-designed icons that are tailored to your exact specifications in terms of shapes, sizes, components, and colors.</p>
              <p>With this power, you can create a visual representation of your brand that stands out from the crowd.</p>{' '}
            </motion.div>
          </ArticleOne>
          <ArticleTwo>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 2.1, duration: 0.3 }} className="start-opacity">
              <div className="article-two">
                <p className="mb-15">Designing custom icons is a great way to create a unique shopping experience for customers. To ensure the icons are effective, I recommend focusing on the following:</p>
                <ul className="mb-15">
                  <li>Keep the icons simple and easy to understand. Complex icons can be confusing and detract from the overall user experience.</li>
                  <li>Make sure the icons are consistent with the overall design of the store. This will help create a cohesive look and feel.</li>
                  <li>Use colors that are in line with the store's branding. This will help customers recognize the icons quickly and easily.</li>
                  <li>Test the icons to make sure they are working properly. This will ensure customers have a smooth and enjoyable shopping experience.</li>
                </ul>
                <p>By following these tips, I am confident that I can create custom icons that will create a unique shopping experience for your customers.</p>
              </div>
            </motion.div>
          </ArticleTwo>
        </ArticleColumns>
      )}
    </SectionWrapper>
  )
}

export default ServiceHeroCustomIconDesign
